import { register } from 'tmr/tmr/ngModuleRegistry'

import * as resourceActionDelete from './resourceActionDelete/resourceActionDelete'
import * as resourceActionDuplicate from './resourceActionDuplicate/resourceActionDuplicate'
import * as resourceActionEdit from './resourceActionEdit/resourceActionEdit'
import * as resourceActionTest from './resourceActionTest/resourceActionTest'
import * as resourceActionView from './resourceActionView/resourceActionView'

export default register(
  'tmr.core.components.resourceActions',
  resourceActionDelete,
  resourceActionDuplicate,
  resourceActionEdit,
  resourceActionTest,
  resourceActionView
)
